import { Item, OrderItem } from 'kiolyn-api';

export default function checkIsPromotionItem(
  item: OrderItem,
  promotionItem: Item
): boolean {
  const splitIds = promotionItem.id.split('_');
  if (splitIds.length !== 2) {
    return false;
  }

  const id = splitIds[1];
  if (
    (promotionItem.type === 'category' && id === item.categoryid) ||
    id === item.itemid
  ) {
    return true;
  } else {
    return false;
  }
}
